import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { EN, IT } from "../content/translations";
import { EN_PAGES, IT_PAGES } from "../content/translations_pages";

const DICTS = { fr: null, en: { ...EN, ...EN_PAGES }, it: { ...IT, ...IT_PAGES } };
export const LANGS = [["fr", "FR"], ["en", "EN"], ["it", "IT"]];
const Ctx = createContext({ lang: "fr", setLang: () => {}, t: (s) => s });

function initial() {
  const q = new URLSearchParams(window.location.search).get("lang");
  if (q && DICTS[q] !== undefined) return q;
  const saved = localStorage.getItem("kouoh_lang");
  if (saved && DICTS[saved] !== undefined) return saved;
  const nav = (navigator.language || "fr").slice(0, 2);
  return DICTS[nav] !== undefined ? nav : "fr";
}

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(initial);
  const setLang = (l) => { localStorage.setItem("kouoh_lang", l); setLangState(l); };
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const t = useMemo(() => {
    const d = DICTS[lang];
    return (s) => (d && typeof s === "string" && d[s]) || s;
  }, [lang]);
  return <Ctx.Provider value={{ lang, setLang, t }}>{children}</Ctx.Provider>;
}

export const useT = () => useContext(Ctx);

export function LangSwitcher({ className = "" }) {
  const { lang, setLang } = useT();
  return (
    <div className={`inline-flex items-center gap-1 text-xs ${className}`} role="group" aria-label="Langue" data-testid="lang-switcher">
      {LANGS.map(([k, l]) => (
        <button key={k} type="button" onClick={() => setLang(k)} data-testid={`lang-${k}`} aria-pressed={lang === k}
          className={`px-2 py-1 rounded-full transition-colors ${lang === k ? "bg-[#1C1917] text-[#FBF9F5]" : "text-[#57534E] hover:text-[#C25E38]"}`}>{l}</button>
      ))}
    </div>
  );
}
